import { createSlice } from "@reduxjs/toolkit";
import { successStoriesAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const successStoriesSlice = createSlice({
  name: "successStories",
  initialState: data,
  reducers: {
    successStoriesSlice(state) {
      state.isLoading = false;
    },
    successStoriesSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    successStoriesSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    successStoriesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const successStoriesHandler = () => async (dispatch: any) => {
  try {
    dispatch(successStoriesAction.successStoriesSlice());
    const response: any = await successStoriesAPI();
    dispatch(successStoriesAction.successStoriesSliceSuccess(response));
  } catch (e: any) {
    dispatch(successStoriesAction.successStoriesSliceFailure(e?.response?.data?.message));
    dispatch(successStoriesAction.successStoriesSliceReset());
  }
};
export default successStoriesSlice.reducer;
export const successStoriesAction = successStoriesSlice.actions;
